import { useUiTheme } from 'framework/uiTheme';
import { Link, Typography } from '@mui/material';
import { PhoneFieldLayoutProps, PhoneFieldLayoutType, BaseFieldLayoutType } from '../../field';

const PhoneFieldLayout: PhoneFieldLayoutType = ({ phone, phoneExtension, label }: PhoneFieldLayoutProps) => {
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const displayValue = phone ? (
    <>
      <Link href={`tel:${phone}`} color="primary" underline="none" variant="body1">
        {phone}
      </Link>

      {phoneExtension && (
        <Typography component="span" variant="body1" className="extension">
          {`ext ${phoneExtension}`}
        </Typography>
      )}
    </>
  ) : null;

  return <BaseFieldLayout value={displayValue} label={label} />;
};

export default PhoneFieldLayout;
